<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="box_1 flex-col">
        <div class="box_2 flex-row">
          <div class="group_2 flex-col">
            <div class="block_1 flex-col">
              <span class="text_11">AI面试官</span>
              <div class="group_11 flex-row justify-between">
                <div class="block_2 flex-col"></div>
                <span class="text_12">提升求职效率</span>
              </div>
              <div class="image-text_4 flex-row justify-between">
                <div class="block_3 flex-col"></div>
                <span class="text-group_4">优化招聘流程</span>
              </div>
              <div class="image-text_5 flex-row justify-between">
                <div class="section_2 flex-col"></div>
                <span class="text-group_5">提高学习效率</span>
              </div>
              <img
                class="image_1"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng321eaa360b73d66285bcc98f3ee5b8a677069cbd510e7d9902faf214fb05aaa6.png"
              />
            </div>
          </div>
          <div class="section_3 flex-col">
            <div class="text-wrapper_3 flex-row justify-between">
              <span class="text_3">登录</span>
              <span class="text_4">注册</span>
            </div>
            <div class="group_5 flex-col"></div>
            <div class="group_6 flex-row">
              <span class="text_5">+86</span>
              <div class="group_7 flex-col"></div>
              <span class="text_6">请输入手机号</span>
            </div>
            <div class="group_8 flex-row">
              <span class="text_7">请输入密码</span>
              <div class="section_4 flex-col justify-between">
                <div class="image-wrapper_3 flex-col">
                  <img
                    class="thumbnail_5"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPngc9f5a76493d3a7efcc0c3a4e0f7d9336a74c5cb786f4f34b8558bb42091a1414.png"
                  />
                  <img
                    class="thumbnail_6"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng839350092963f8899e38e9cad1376e3e3d3f815c1ecce9274e0a1a0b50791c11.png"
                  />
                </div>
                <div class="image-wrapper_4 flex-row justify-between">
                  <img
                    class="thumbnail_7"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPngc99bba77668bbd545253952eb5047a276f18d39bbe8abe3b34aa8518dd812c9a.png"
                  />
                  <img
                    class="thumbnail_8"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng44a27b8dcbcda6e1ec6d18a0050345ee0b60e96d40b1920723fb91273a484436.png"
                  />
                </div>
              </div>
            </div>
            <div class="image-text_6 flex-col justify-between">
              <div class="text-wrapper_2 flex-col"><span class="text_8">登录</span></div>
              <div class="text-group_6 flex-row justify-between">
                <span class="text_9">忘记密码</span>
                <span class="text_10">短信验证码登录</span>
              </div>
            </div>
          </div>
          <div class="group_10 flex-col"><div class="box_5 flex-col"></div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />